import { BaseHttpController } from "@Core/controller/BaseHttpController";
import { IPTZCameraHttpController, IUpdatePatrolModeProps } from "../IPTZCameraHttpController";
import { PTZCamera } from "@EcamModel/model/PTZCamera";
import { AxiosInstance } from "axios";
import { PTZCameraConfigs } from '@EcamModel/model/PTZCameraConfigs';

export class PTZCameraHttpController extends BaseHttpController<PTZCamera> implements IPTZCameraHttpController {
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'ptz-camera', client);
    }
    async updatePatrolMode(props: IUpdatePatrolModeProps): Promise<PTZCamera> {
        return await this.doPost({ path: 'update-patrol-mode', body: props }).then(res => res.data);
    }

    async refreshLatestPTZCameraConfig(cameraId: number): Promise<PTZCameraConfigs> {
        return await this.doGet({ path: `refresh-latest-configs/${cameraId}` }).then((res) => res.data);
    }
}